export const getValue = (value: string | { label: string } | null): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (value) {
    return value.label;
  }
  return '';
};
